
import React, { useState } from 'react';
import './carousel.css';
import { Carousel } from 'primereact/carousel';
import { Modal, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Button, Image, Box, Text, Flex } from '@chakra-ui/react';

export const Gallery = () => {
    const data = [
        {
            image: "https://i.postimg.cc/NFdHRR6q/oil.jpg",
            caption: `<div>Applications of Oil Refinery Services
      Sector : Natural Resources
      Area : Zambezi Region
      Issuer : Ministry of Agriculture and Forestry
      Dates : 01 Jan 2023 - 01 April 2023 <br/><span>Next line</span></div>`,
        },
        {
            image: "https://i.postimg.cc/wx4P6ZN2/road.jpg",
            caption: `<div>Request for road repair tender
      Sector : Roads and Safety
      Area : Gobabis
      Issuer : Roads Authority Namibia
      Dates : 01 Jan 2023 - 01 April 2023</div>`,
        },
        {
            image: "https://i.postimg.cc/fRQhN14F/teaching.jpg",
            caption: `<div>Sustained Long-Term Computational Education Services
      Sector : Education
      Area : Hardap
      Issuer : Ministry of Education
      Dates : 01 Jan 2023 - 01 April 2023</div>`,
        },
        {
            image: "https://i.postimg.cc/DyH1yd5R/fishing.jpg",
            caption: `<div>Request of Marine Life Capture Services
      Sector : Wildlife and Tourism
      Area : Khomas Region
      Issuer : Ministry of Tourism
      Dates : 01 Jan 2023 - 01 April 2023</div>`,
        },
        {
            image: "https://i.postimg.cc/T3QL5VcR/health.png",
            caption: `<div>Provision of Short-Tem Insurance Brokerage Services
      Sector : Insurance
      Area : Khomas Region
      Issuer : Khomas City Council
      Dates : 01 Jan 2023 - 01 April 2023</div>`,
        },
        {
            image: "https://i.postimg.cc/Pr9FsDD5/tailor.jpg",
            caption: `<div>Tender for security personnel
      Sector : Clothing
      Area : Khomas Region
      Issuer : Ministry of Defense
      Dates : 01 Jan 2023 - 01 April 2023</div>`,
        },
        {
            image: "https://i.postimg.cc/xdMdyLvJ/handling.jpg",
            caption: `<div>Ground Handling Services HKIA
      Sector : Travel and Aerospace
      Area : Khomas Region
      Issuer : Airports Company Namibia
      Dates : 01 Jan 2023 - 01 April 2023</div>`,
        },
        {
            image: "https://i.postimg.cc/T3r8t0s6/catering.jpg",
            caption: `<div>Tender for Catering Services
      Sector : Government Summits
      Area : Khomas Region
      Issuer : Government of Namibia
      Dates : 01 Jan 2023 - 01 April 2023</div>`,
        },
        {
            image: "https://i.postimg.cc/k5m2HjXF/insu.jpg",
            caption: `<div>Provision of Short-Tem Insurance Brokerage Services
      Sector : Insurance
      Area : Khomas Region
      Issuer : Khomas City Council
      Dates : 01 Jan 2023 - 01 April 2023</div>`,
        },
    ];
    
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);
    const [currentCaption, setCurrentCaption] = useState(null);

    const openModal = (image, caption) => {
        setCurrentImage(image);
        setCurrentCaption(caption);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setCurrentImage(null);
        setCurrentCaption(null);
    };

    const handleImageClick = (image, caption) => {
        openModal(image, caption);
    };

    const responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 6,
            numScroll: 3
        },
        {
            breakpoint: '768px',
            numVisible: 4,
            numScroll: 2
        },
        {
            breakpoint: '560px',
            numVisible: 2,
            numScroll: 1
        }
    ];

    const productTemplate = (item) => {
        return (
            <Box className="carousel-item" onClick={() => handleImageClick(item.image, item.caption)} border="1px" borderColor="gray.200" borderRadius="md" overflow="hidden">
                <Image src={item.image} alt={item.caption} style={{ width: '100%', height: '300px', objectFit: 'cover', cursor: 'pointer' }} />
                {/* <Box className="carousel-caption" p="4" dangerouslySetInnerHTML={{ __html: item.caption }} /> */}
            </Box>
        );
    };

    return (
        <Box id="portfolio" className="carousel" textAlign="center">
            <Text fontSize="50px" fontWeight="bold" mb="4">Featured Tenders</Text>
            <Button as="a" href="https://innobidfront-staging.onrender.com/"  className="btn btn-custom btn-lg page-scroll" mb="4" colorScheme='blue'>
                Click here to bid and to view more tenders
            </Button>
            <Box p="4">
                <Carousel 
                    value={data} 
                    numVisible={6} 
                    numScroll={3} 
                    responsiveOptions={responsiveOptions} 
                    className="custom-carousel" 
                    circular 
                    autoplayInterval={3000} 
                    itemTemplate={productTemplate}
                />
            </Box>
            <Modal isOpen={modalIsOpen} onClose={closeModal} size="xl" isCentered>
                <ModalContent>
                    <ModalHeader>Tender Details</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Image src={currentImage} alt="Detailed View"  height="240px" width="100%" objectFit="cover" />
                        <Box mt="4" dangerouslySetInnerHTML={{ __html: currentCaption }} />
                    </ModalBody>
                    <ModalFooter>
                      <Flex justifyContent="space-between" gap={200}>
                        <Button onClick={closeModal} colorScheme="red" alignContent="left" mr={3}>Close</Button>
                        <Button as="a" href="https://innobidfront-staging.onrender.com/" colorScheme='blue' alignContent="right" mr={4}>Bid</Button>
                        </Flex>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    );
};




